import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_backoffice/about/create/')({
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/_backoffice/about/create/"!</div>
}
